// Module Federation requires a dynamic import at the entry point so that
// shared modules (react, react-dom, etc.) are initialised by the MF runtime
// before any app code runs — prevents "eager consumption" errors.
// eslint-disable-next-line import/extensions
import('./bootstrap');
